import React from 'react'
import {
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  CardBody,
  Button,
  ModalFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import SimpleBar from "simplebar-react";

export default function ForwardMsgModal({ contacts, modal, toggle, forwardMessage }) {
  const renderContacts = () => {
    return contacts?.map((contact, i) => (
      <ListGroupItem key={i} onClick={() => forwardMessage({ ...contact, index: i })}>
        <div style={{ display: "flex" }} className="cursor-pointer">
          <div className="chat-user-img align-self-center me-3">
            <div className="avatar-xs">
              <img
                src={
                  contact?.isGroupChat
                    ? "https://static.vecteezy.com/system/resources/thumbnails/021/063/599/small/group-coaching-icon-vector.jpg"
                    : contact?.user?.imageSrc
                }
                className="rounded-circle avatar-xs"
                alt="chatvia"
              ></img>
            </div>
          </div>
          <span className="m-auto">{contact?.name}</span>
        </div>
      </ListGroupItem>
    ));
  };

  return (
    <Modal backdrop="static" isOpen={modal} centered toggle={toggle}>
      <ModalHeader toggle={toggle}>Forward to...</ModalHeader>
      <ModalBody>
        <CardBody className="p-2">
          <SimpleBar style={{ maxHeight: "200px" }}>
            <ListGroup
              style={{ maxHeight: "236px", overflowY: "scroll" }}
            >
              {/* <SelectContact handleCheck={() => {}} /> */}
              {renderContacts()}
            </ListGroup>
          </SimpleBar>
        </CardBody>
      </ModalBody>
    </Modal>
  )
}
